import { computed, inject, Injectable, signal } from '@angular/core';
import { OrderApiResponseStateService } from './order-api-response-state.service';
import { AutopayDetails, PaymentCardTypeResponse, PaymentProductResponse, PaymentResponse, PaymentResponseType } from '../../../../../models/order/api-models/order-payment-response.model';

@Injectable({ providedIn: 'root' })
export class OrderPaymentResponseService {
    internetViPaymentCardTypeResponse = signal<PaymentCardTypeResponse>(null);
    wirelessViPaymentCardTypeResponse = signal<PaymentCardTypeResponse>(null);
    videoViPaymentCardTypeResponse = signal<PaymentCardTypeResponse>(null);
    todaysChargesPaymentCardTypeResponse = signal<PaymentCardTypeResponse>(null);

    private orderApiResponseStateService = inject(OrderApiResponseStateService);
    attPayment = this.orderApiResponseStateService.attData;
    rc1Payment = this.orderApiResponseStateService.rc1Data;
    viPayment = this.orderApiResponseStateService.viPaymentData;
    dtvPayment = this.orderApiResponseStateService.dtvPaymentData;
    viPaymentProductResponse = computed(() => {
        const viPayment = this.viPayment();
        if (viPayment) {
            return viPayment.ResponseHeader?.ProductResponse.find(pr => pr.Type === 'WIRELESS') || null;
        }
        return null;
    });

    internetPaymentCardType = computed(() => {
        return this.internetViPaymentCardTypeResponse()?.ResponseHeader?.ProductResponse?.
        find(item => item.Type === PaymentResponseType.RC1 || item.Type === PaymentResponseType.ATT)?.CardType || null;
    })

    wirelessPaymentCardType = computed(() => {
        return this.wirelessViPaymentCardTypeResponse()?.ResponseHeader?.ProductResponse?.
        find(item => item.Type === PaymentResponseType.WIRELESS)?.CardType || null;
    })

    videoPaymentCardType = computed(() => {
        return this.videoViPaymentCardTypeResponse()?.ResponseHeader?.ProductResponse?.
        find(item => item.Type === PaymentResponseType.VIDEO)?.CardType || null;
    })

    internetPaymentProductResponse = computed(() => {
        const attPayment = this.attPayment();
        if (attPayment) {
            return attPayment.ResponseHeader?.ProductResponse.find(pr => pr.Type === 'ATT') || null;
        }

        const rc1Payment = this.rc1Payment();
        if (rc1Payment) {
            return rc1Payment.ResponseHeader?.ProductResponse.find(pr => pr.Type === 'RC1') || null;
        }
        return null;
    });

    isInternetPaymentRequired() {
        const att = this.attPayment();
        const rc1 = this.rc1Payment();
        if (att) {
            const attError = this.hasPaymentErrors(att);
            return attError;
        }

        if (rc1) {
            const rc1Error = this.hasPaymentErrors(rc1);
            return rc1Error;
        }

        return true;
    }

    isWirelessPaymentRequired() {
        const viPayment = this.viPayment();
        if (viPayment) {
            const viPaymentError = this.hasPaymentErrors(viPayment);
            return viPaymentError;
        }
        return true;
    }

    isVideoPaymentRequired() {
        const viPayment = this.dtvPayment();
        if (viPayment) {
            const viPaymentError = this.hasPaymentErrors(viPayment);
            return viPaymentError;
        }
        return true;
    }


    getPaymentError(response: PaymentResponse): string | null {
        return response.ResponseHeader.ProductResponse
            .find(resp => resp.Code !== '0000')
            ?.Message ?? '';
    }

    getAutopayDetails(response: PaymentProductResponse): AutopayDetails | null {
        if ((response.AutopayAmount === undefined  || response.AutopayAmount === null) && !response.AutopayCardType && !response.AuthCode) {
            return null;
        }

        return {
            amount: response.AutopayAmount,
            cardType: response.AutopayCardType,
            isDebitCard: response.IsAutopayDebitCard === 'true',
            authCode: response.AuthCode
        };
    }

    private hasPaymentErrors(payment: PaymentResponse) {
        if (!payment) return false;
        return payment.ResponseHeader?.ProductResponse?.some(r => r.Code !== '0000');
    }

}